import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryChargingIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M18.3603 7.10078H14.7603V5.30078H18.3603V7.10078ZM6.0001 8.24072H11.3895L9.80589 10.0407H6.0001C5.66873 10.0407 5.4001 10.3094 5.4001 10.6407V15.4407C5.4001 15.7721 5.66873 16.0407 6.0001 16.0407H9.70911L9.29339 17.8407H6.0001C4.67462 17.8407 3.6001 16.7662 3.6001 15.4407V10.6407C3.6001 9.31524 4.67461 8.24072 6.0001 8.24072ZM10.525 17.8407L10.9407 16.0407H10.9408L11.4748 13.7286H8.15991L11.4044 10.0407H11.4042L12.8475 8.4002H13.4677L13.4677 8.40039H13.4678L12.5119 12.5389H15.8167L11.1392 17.8671H10.519L10.5251 17.8407H10.525ZM18.0001 16.0407H14.3391L12.759 17.8407H18.0001C19.3256 17.8407 20.4001 16.7662 20.4001 15.4407V10.6407C20.4001 9.31524 19.3256 8.24072 18.0001 8.24072H14.7362L14.3204 10.0407H18.0001C18.3315 10.0407 18.6001 10.3094 18.6001 10.6407V15.4407C18.6001 15.7721 18.3315 16.0407 18.0001 16.0407ZM5.64014 7.10078H9.24014V5.30078H5.64014V7.10078Z"
      />
    </SvgIcon>
  );
});
